import React from 'react';
import "../App.css"
import { Container } from '../style';
import { useTranslation } from "react-i18next";


const EduPresentation = () => {
    const { t } = useTranslation();

    return (
        <Container>

            <br/>
            <br/>
            <br/>
        
            <nav className="tabs">
        <ul className="tabs__list">
          <li className="tabs__item tabs__item--active">{t('tabs.allMaterials')}</li>
          <li className="tabs__item">{t('tabs.presentations')}</li>
          <li className="tabs__item">{t('tabs.news')}</li>
        </ul>
      </nav>
      <main className="content">
        <section className="presentations">
          <h2 className="presentations__title">{t('presentations.title')}</h2>
          <div className="presentations__grid">
            <article className="presentation-card">
              <h3 className="presentation-card__title">{t('presentations.items.financialLiteracy')}</h3>
              <a href="#" className="presentation-card__link">{t('presentations.viewPresentation')}</a>
            </article>
            <article className="presentation-card">
              <h3 className="presentation-card__title">{t('presentations.items.bankManagement')}</h3>
              <a href="#" className="presentation-card__link">{t('presentations.viewPresentation')}</a>
            </article>
            <article className="presentation-card">
              <h3 className="presentation-card__title">{t('presentations.items.riskManagement')}</h3>
              <a href="#" className="presentation-card__link">{t('presentations.viewPresentation')}</a>
            </article>
          </div>
        </section>
        <section className="news">
          <h2 className="news__title">{t('news.title')}</h2>
          <div className="news__grid">
            <article className="news-card">
              <h3 className="news-card__title">{t('news.items.annualReport.title')}</h3>
              <p className="news-card__description">{t('news.items.annualReport.description')}</p>
              <span className="news-card__tag">{t('news.tags.report')}</span>
              <a href="#" className="news-card__link">{t('news.readMore')}</a>
            </article>
            <article className="news-card">
              <h3 className="news-card__title">{t('news.items.quarterlyReport.title')}</h3>
              <p className="news-card__description">{t('news.items.quarterlyReport.description')}</p>
              <span className="news-card__tag">{t('news.tags.quarterlyReport')}</span>
              <a href="#" className="news-card__link">{t('news.readMore')}</a>
            </article>
            <article className="news-card">
              <h3 className="news-card__title">{t('news.items.programAnalysis.title')}</h3>
              <p className="news-card__description">{t('news.items.programAnalysis.description')}</p>
              <span className="news-card__tag">{t('news.tags.analytics')}</span>
              <a href="#" className="news-card__link">{t('news.readMore')}</a>
            </article>
          </div>
        </section>
      </main>

        <br/>
            <br/>
            <br/>

        </Container>
    );
}

export default EduPresentation;
